const generateEditorLinkToEntry = (appSettings, entryId) =>
  `https://app.contentful.com/spaces/${appSettings.contentful.spaceId}/environments/${appSettings.contentful.environment}/entries/${entryId}`;

export default generateEditorLinkToEntry;
